import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import { FontWeight, Spacing } from 'modules/styles/variables';
import { Color } from 'modules/styles/colors';

import TouchablePanelList from 'components/UI/Panel/TouchablePanelList';
import Spinner from 'components/UI/Spinner/Spinner';

import { TriageCondition } from 'store/triageGyant/types';
import {
  triageGyantConditionsSortedSelector,
  triageGyantResultsIsFetchingSelector,
  triageGyantCurrentCaseIdSelector
} from 'store/triageGyant/selectors';
import { getTriageResults } from 'store/triageGyant/actions';
import { RootState } from 'store/types';

import TriageHeader from 'screens/TriageGyant/TriageGyantHeader';
import CauseCard from 'screens/TriageGyant/ResultsScreens/LikelyCausesList/LikelyCauseListCard';
import { TRIAGE_ROUTES } from 'screens/TriageGyant/constants';

import { MuiContainer, MuiBox, MuiTypography } from 'theme/material-ui';

export interface Props {
  getTriageResults: typeof getTriageResults;
  sortedConditions: TriageCondition[];
  isFetching: boolean;
  currentCaseId: string;
}

export function TriageCausesListComponent(props: Props) {
  const { sortedConditions, currentCaseId } = props;
  const { caseId = '' } = useParams();
  const history = useHistory();

  useEffect(() => {
    if (currentCaseId !== caseId) {
      props.getTriageResults(caseId);
    }
  }, []);

  const onConditionDetailPress = (conditionId: string) => {
    history.push(`${TRIAGE_ROUTES.CAUSE_DETAIL.BASE_URL}/${conditionId}`);
  };

  return (
    <MuiBox display="flex" flexDirection="column" height="100%" bgcolor={Color.grayLight3}>
      <TriageHeader />
      {props.isFetching ? (
        <MuiBox height="100%" pt={Spacing.xLarge} display="flex" justifyContent="center">
          <Spinner />
        </MuiBox>
      ) : (
        <MuiContainer maxWidth="md">
          <MuiBox mx={Spacing.small}>
            <MuiBox mt={Spacing.medium} mb={Spacing.small}>
              <MuiTypography variant="h5" fontWeight={FontWeight.semibold}>
                Possible Causes
              </MuiTypography>
            </MuiBox>
            <TouchablePanelList
              data={sortedConditions}
              emptyCaption="Unable to load possible causes"
              keyExtractor={(item: TriageCondition) => item.condition.toString()}
              renderItem={(item: TriageCondition, index: number) => (
                <CauseCard item={item} index={index} />
              )}
              onItemPressed={item => onConditionDetailPress(item.condition)}
            />
          </MuiBox>
        </MuiContainer>
      )}
    </MuiBox>
  );
}

const mapDispatch = {
  getTriageResults
};

const mapState = (state: RootState) => ({
  sortedConditions: triageGyantConditionsSortedSelector(state),
  isFetching: triageGyantResultsIsFetchingSelector(state),
  currentCaseId: triageGyantCurrentCaseIdSelector(state)
});

export default connect(mapState, mapDispatch)(TriageCausesListComponent);
